import React from "react";
import classes from './WelcomeScreenSuggestedActions.module.css';
import SuggestedAction from "../../../../UiKit/SuggestedAction/SuggestedAction";
import useWebChat from "../../../../Hooks/useWebChat";
import { useLanguage } from "../../../../UiKit/Wizard/langugeContext";
import { translations } from '../translations';

function WelcomeScreenSuggestedActions() {
    const { store, sendLoggingEventToBackend } = useWebChat();
    const { currentLanguage } = useLanguage();
    const welcomeScreenTranslations = translations[currentLanguage]["welcomeScreenSuggestedActions"];

    const pushDataLayerEvent = (message) => {
        window.dataLayer.push({
            event: 'cici_event',
            action: `Welcome Screen: ${message}`,
        });
    }

    const onSuggestedActionClick = (message) => {
        pushDataLayerEvent(message);
        store.dispatch({
            type: "WEB_CHAT/SEND_MESSAGE",
            payload: {
                text: message,
            },
        });
        sendLoggingEventToBackend({

            intentName: currentLanguage === "en" ? message + " WelcomeScreenSuggestedAction" : message + " WelcomeScreenSuggestedActionSpanish",
            text: message,

        })
    };

    return (
        <div className={`${classes['welcome-screen-suggested-actions']}`}>
            {welcomeScreenTranslations.suggestedActions.map((action, index) => (
                <SuggestedAction
                    key={index}
                    onClick={() => onSuggestedActionClick(action.title)}
                    tabIndex="0"
                >
                    {action.title}
                </SuggestedAction>
            ))}
        </div>
    );
}

export default WelcomeScreenSuggestedActions;
